import { MouseEvent, useState } from 'react';

export const useActionPopover = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleOpenPopover = (event: MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget);
  const handleClosePopover = () => setAnchorEl(null);

  return {
    anchorEl,
    handleOpenPopover,
    handleClosePopover,
  };
};
